let loading = document.querySelector('body.loading');

window.onload = function () {
    if (loading) {
        if (loading.classList.contains('loading')) {
            loading.classList.add('loading--finished');

            setTimeout(function () {
                loading.classList.remove('loading--finished');
                loading.classList.remove('loading');

                document.dispatchEvent(new CustomEvent('bodyLoadingFinished'));
            }, 300);
        }
    }
}